/**
 * MHR Protocol Types
 */

export type ProtocolStatus = 'setup' | 'active' | 'paused' | 'closed';

export interface Protocol {
  id: string;
  site_id: string;
  protocol_number: string;
  protocol_title: string | null;
  sponsor_name: string | null;
  therapeutic_area: string | null;
  phase: string | null;
  status: ProtocolStatus;
  criteria_version: number;
  created_at: string;
  created_by: string;
  updated_at: string;
  // Computed fields from joins
  criteria_count?: number;
  review_count?: number;
}

export interface ProtocolFormData {
  protocol_number: string;
  protocol_title: string;
  sponsor_name: string;
  therapeutic_area: string;
  phase: string;
  status?: ProtocolStatus;
}

export interface ProtocolListResponse {
  data: Protocol[];
  count: number;
}

export interface ProtocolStats {
  criteria: {
    total: number;
    inclusion: number;
    exclusion: number;
  };
  reviews: {
    total: number;
    completed: number;
    pending: number;
  };
  eligibility: {
    eligible: number;
    excluded: number;
    review_required: number;
  };
}

// Protocol phases commonly used in clinical trials
export const PROTOCOL_PHASES = [
  'Phase 1',
  'Phase 1/2',
  'Phase 2',
  'Phase 2/3',
  'Phase 3',
  'Phase 3b',
  'Phase 4',
  'Observational',
  'Registry',
] as const;

// Common therapeutic areas
export const THERAPEUTIC_AREAS = [
  'Cardiology',
  'Dermatology',
  'Endocrinology',
  'Gastroenterology',
  'Hematology',
  'Hepatology',
  'Immunology',
  'Infectious Disease',
  'Nephrology',
  'Neurology',
  'Oncology',
  'Ophthalmology',
  'Pulmonology',
  'Psychiatry',
  'Rare Disease',
  'Rheumatology',
  'Urology',
  'Vaccines',
  'Other',
] as const;
